import type { WeekSchedule } from '@/types';

/**
 * Recalculates weekly totals (volume, TSS, duration) based on scheduled workouts.
 * This ensures the Week Card UI reflects manual edits immediately.
 */
export function recalculateWeekSummary(week: WeekSchedule): WeekSchedule {
    let totalDistance = 0;
    let totalDuration = 0;
    let totalTSS = 0;

    week.days.forEach(day => {
        // AM Workout
        if (day.workout) {
            totalDistance += (day.workout.distance || day.workout.estimatedDistance || 0);
            totalDuration += (day.workout.estimatedDuration || 0);
            totalTSS += (day.workout.tss || day.workout.estimatedTSS || 0);
        }
        // PM Workout
        if (day.secondary) {
            totalDistance += (day.secondary.distance || day.secondary.estimatedDistance || 0);
            totalDuration += (day.secondary.estimatedDuration || 0);
            totalTSS += (day.secondary.tss || day.secondary.estimatedTSS || 0);
        }
    });

    return {
        ...week,
        // Update both volume fields for compatibility
        volume: Math.round(totalDistance),

        // Update targets to reflect the new reality (User Option B: Local sync)
        targetVolume: Math.round(totalDistance),
        targetTSS: Math.round(totalTSS),

        // Update other metrics
        targetDuration: Math.round(totalDuration),

        rTSS: Math.round(totalTSS),
    };
}
